import style from "./style.scss";
import { useId } from "preact/hooks";

const Textbox = ({ value, label, suffix = null, onInput = null, ...props }) => {
  const id = useId();

  return (
    <div class={style.wrapper}>
      <label for={id}>{label}</label>
      <div class={style.textbox}>
        <div class={style.suffix} aria-hidden="true" data-suffix={suffix}>
          {suffix}
        </div>
        <input id={id} value={value} onInput={onInput} {...props} />
      </div>
    </div>
  );
};

export default Textbox;
